var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.353 53.716L5.038 40.32a25.68 25.68 0 01-3.461-12.924c0-14.264 11.655-25.861 25.974-25.861 6.948 0 13.473 2.691 18.367 7.578C50.824 14 53.526 20.5 53.513 27.408c0 14.264-11.655 25.862-25.974 25.862h-.013a26.065 26.065 0 01-12.414-3.151l-13.76 3.597zm14.406-8.285l.785.47a21.706 21.706 0 0010.982 3.002h.013c11.891 0 21.579-9.637 21.579-21.495 0-5.742-2.242-11.138-6.313-15.206C38.733 8.133 33.304 5.9 27.539 5.9c-11.904 0-21.592 9.637-21.592 21.495 0 4.056 1.133 8.012 3.3 11.436l.51.819-2.178 7.925 8.18-2.145z",
    fill: "#000",
    fillOpacity: 0.24
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.531 52.333l3.517-12.776A24.583 24.583 0 012.74 27.234c0-13.597 11.117-24.658 24.755-24.658 6.628 0 12.838 2.572 17.511 7.227s7.243 10.853 7.243 17.443c0 13.597-11.117 24.658-24.754 24.658h-.012a24.844 24.844 0 01-11.83-3L2.53 52.333z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.634 53.227l3.64-13.229a25.358 25.358 0 01-3.419-12.764c0-14.087 11.51-25.54 25.652-25.54 6.862 0 13.306 2.658 18.139 7.484 4.845 4.827 7.513 11.245 7.501 18.068 0 14.087-11.51 25.54-25.652 25.54h-.012a25.742 25.742 0 01-12.26-3.11l-13.59 3.552zm14.228-8.182l.774.465a21.435 21.435 0 0010.847 2.965h.012c11.744 0 21.311-9.518 21.311-21.229 0-5.671-2.213-11-6.235-15.017-4.02-4.018-9.383-6.223-15.076-6.223-11.756 0-21.324 9.518-21.324 21.228 0 4.006 1.12 7.913 3.26 11.294l.503.809-2.152 7.827 8.08-2.12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.088 16.54c-.48-1.065-.984-1.09-1.439-1.102-.369-.012-.8-.012-1.23-.012-.43 0-1.119.159-1.71.796-.59.637-2.237 2.18-2.237 5.329 0 3.135 2.3 6.173 2.62 6.602.319.429 4.438 7.08 10.944 9.64 5.41 2.132 6.517 1.703 7.685 1.593 1.181-.11 3.788-1.544 4.33-3.038.528-1.495.528-2.769.368-3.038-.16-.27-.59-.429-1.23-.747-.64-.319-3.787-1.862-4.377-2.083-.59-.22-1.021-.318-1.44.319-.43.637-1.66 2.07-2.028 2.499-.37.428-.75.477-1.39.159-.64-.318-2.705-.992-5.152-3.173-1.907-1.69-3.198-3.785-3.567-4.422-.369-.637-.037-.98.283-1.298.283-.282.64-.747.96-1.115.32-.367.43-.637.639-1.066.209-.428.11-.796-.05-1.114-.16-.319-1.413-3.467-1.98-4.728z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 27.389,
    y1: 52.33,
    x2: 27.389,
    y2: 2.573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20B038"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D66A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h55v55H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: -4.647,
    y: -4.465,
    width: 64.161,
    height: 64.181,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "effect1_foregroundBlur"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/whatsapp.0818abc1.svg";
export { ForwardRef as ReactComponent };